export default "__VITE_ASSET__Br9kias6__"